import { CardDetalhe } from "@/components/Card/CardDetalhe";
import { ProductItem } from "@/services/api/productsServices.api";
import theme from "@/styles/themes/theme";
import { Stack, Typography } from "@mui/material";
import { ListMagnifyingGlass } from "@phosphor-icons/react";

import { SwapInstructions } from "../SwapInstructions/SwapInstructions";

export const ProductDetails: React.FC<ProductItem> = ({
  id,
  imageUrl,
  title,
  description,
  productCoinValueText,
  categoryId,
  partnerId,
  productId,
  itemSwapInstructions
}) => {
  if (!id) {
    return (
      <Stack direction="row" justifyContent="center" alignItems="center" height="40vh" spacing={2}>
        <ListMagnifyingGlass size={36} color={theme.palette.grey[500]} />

        <Typography variant="h5" color={theme.palette.grey[500]}>
          Produto não encontrado
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack display="flex" justifyContent="center" gap={4} px={{ xl: 16, lg: 0, md: 0, xs: 0 }}>
      <CardDetalhe
        id={id}
        link="#"
        image={imageUrl || "/placeholder.png"}
        parceiro={title}
        title={description}
        km={productCoinValueText}
        categoryId={categoryId}
        partnerId={partnerId}
        productId={productId}
      />

      <SwapInstructions itemSwapInstructions={itemSwapInstructions} />
    </Stack>
  );
};
